/**
 * SendLogRequest
 *
 * Module to fire all UI logging events for the search page.
 *
 * @param  {string} name [name of the log event]
 * @param  {object} data [data to log]
 *
 * @return {function}
 */

OT.createNS('OT.Search.sendLogRequest');

OT.Search.sendLogRequest = function(name, type, data) {
    name = OT.Search.Config.get('LogEventPrefix') + name;

    // Check if all logging has been disabled
    if (!OT.Search.Config.get('EnableAllLogging')) {
        return false;
    }

    // Check if interaction logging has been disabled
    if (!OT.Search.Config.get('EnableInteractionLogging')) {
        return false;
    }

    var defaults = {
        source: 'SearchResults',
        searchConfig: OT.Search.Config.getAll(),
        searchParams: OT.Search.Params.getAll(),
        resultsCount: {
            Total: OT.Search.Data.get().Results.Total,
            TotalAvailable: OT.Search.Data.get().Results.TotalAvailable,
            TotalUnavailable: OT.Search.Data.get().Results.TotalUnavailable
        }
    };

    OT.Common.sendLogRequest(name, _.extend(defaults, data || {}));
};
